import Caption from '@zenbusiness/common-components/Caption';
import { useLocation, useMatch } from 'react-router-dom';

import { styled } from '@mui/material/styles';

import { ROUTES } from '#client/manifest';
import isWebView from '#client/utils/isWebView';

const releaseYear = new Date().getFullYear();

const texasEmoji = ['🐐', '🌮', '❤️'];

const chooseTexasEmoji = () => texasEmoji[Math.floor(Math.random() * texasEmoji.length)];

const Colophon = styled('div')(() => ({
  display: 'flex',
  alignItems: 'start',
  gap: '0.75rem',
  flexDirection: 'column',
  margin: '0 auto',
  maxWidth: '1440px',
  paddingBlock: '1.5rem',
  textAlign: 'center'
}));

function AppFooter() {
  const { pathname } = useLocation();
  const isDashboardHome = useMatch(ROUTES.company, pathname);

  if (isWebView) {
    return null;
  }

  return (
    <Colophon>
      {isDashboardHome && (
        <Caption size="sm">
          {/* eslint-disable-next-line max-len */}
          ZenBusiness is a financial technology company and is not a bank. Banking services provided by Thread Bank; Member FDIC. The ZenBusiness Visa® Debit Card is issued by Thread Bank pursuant to a license from Visa U.S.A. Inc. and may be used everywhere Visa debit cards are accepted. Your funds are FDIC insured up to $250,000 through Thread Bank.; Member FDIC.
        </Caption>
      )}

      <Caption size="lg" color="focus50">
        {`Made with ${chooseTexasEmoji()} remotely by ZenBusiness INC © ${releaseYear} All Rights Reserved.`}
      </Caption>
    </Colophon>
  );
}

export default AppFooter;
